import { getExperimentValue } from '@moojo/misc'
import { normalizeLang } from '@moojo/shared-config'
import type { StatsigClient } from '@statsig/js-client'
import { z } from 'zod'

export function applyLauncherTextExperiment(statsigClient: StatsigClient, brandName: string): string {
  const defaultText = `Shop ${brandName}`

  const experimentText = getExperimentValue<string>(statsigClient, {
    experimentName: 'launcher_text',
    parameterName: 'text',
    defaultValue: defaultText,
    parser: z.string(),
  })

  return experimentText.replace('[BRAND_NAME]', brandName)
}

export function applySiamoNoiLauncherTextExperiment(statsigClient: StatsigClient, lang: string): string {
  const experimentText = getExperimentValue<string>(statsigClient, {
    experimentName: 'launcher_text_siamo_noi',
    parameterName: normalizeLang(lang).toUpperCase(),
    defaultValue: '',
    parser: z.string(),
  })

  return experimentText
}
